/**
 * Created by iamso on 03.05.19.
 */

cleverapps.Event = function (data) {
    this.features = data.features || [];
    this.options = data.options || {};
    this.projects = data.projects;
    this.networks = data.networks;

    this.start = cleverapps.convertToTimezone(data.start);
    this.finish = cleverapps.convertToTimezone(data.finish);
    this.toolApplicable = data.toolApplicable;
    this.tool = data.tool;
};

cleverapps.Event.prototype.getInfo = function () {
    const info = { ...this };
    info.start = cleverapps.convertFromTimezone(info.start);
    info.finish = cleverapps.convertFromTimezone(info.finish);

    return info;
};

cleverapps.Event.prototype.isRunning = function () {
    return this.start.getTime() <= Date.now() && Date.now() <= this.finish.getTime();
};

cleverapps.Event.prototype.getTimeBeforeStart = function () {
    return Math.max(0, this.start.getTime() - Date.now());
};

cleverapps.Event.prototype.getTimeAfterFinish = function () {
    return Math.max(0, Date.now() - this.finish.getTime());
};

cleverapps.Event.prototype.getTimeLeft = function () {
    return this.finish.getTime() - Date.now();
};

cleverapps.Event.prototype.getStartTime = function () {
    return this.start.getTime();
};

cleverapps.Event.prototype.isAvailable = function () {
    if (this.networks) {
        if (Array.isArray(this.networks) && !this.networks.includes(connector.info.source)) {
            return false;
        }
        if (this.networks.except && this.networks.except.includes(connector.info.source)) {
            return false;
        }
    }

    if (this.projects && this.projects.indexOf(cleverapps.config.name) === -1) {
        return false;
    }

    return true;
};

const EventManager = function () {
    this.currentFeatures = {};
    this.events = [];

    if (bundles.main.jsons.friday_schedule) {
        this.events = bundles.main.jsons.friday_schedule.getJson().filter((eventData) => !eventData.debug || cleverapps.config.debugMode).map((eventData) => new cleverapps.Event(eventData));
    }

    this.setCurrentFeatures();
};

EventManager.prototype.isActive = function (feature) {
    return this.currentFeatures[feature] && this.currentFeatures[feature].isRunning();
};

EventManager.prototype.listCurrentFeatures = function () {
    return Object.keys(this.currentFeatures).filter(function (feature) {
        return this.currentFeatures[feature].isRunning();
    }, this);
};

EventManager.prototype.getFeatureEvent = function (feature) {
    return this.currentFeatures[feature];
};

EventManager.prototype.isEventApplicable = function (event) {
    if (cleverapps.config.debugMode && event.toolApplicable !== undefined) {
        return event.toolApplicable;
    }

    return event.isRunning() && event.isAvailable();
};

EventManager.prototype.setCurrentFeatures = function () {
    const candidates = this.events.filter(this.isEventApplicable.bind(this));

    this.currentFeatures = {};

    candidates.forEach(function (event) {
        event.features.forEach((feature) => {
            this.currentFeatures[feature] = event;
        });
    }, this);
};

EventManager.prototype.listFeatureEvents = function (feature) {
    return this.events.filter((event) => event.features.includes(feature) && event.isAvailable());
};

EventManager.prototype.getNextFeatureEvent = function (feature) {
    const candidates = this.listFeatureEvents(feature).filter((event) => event.getTimeBeforeStart() > 0).sort((a, b) => a.getTimeBeforeStart() - b.getTimeBeforeStart());

    return candidates[0];
};

EventManager.prototype.getLastFeatureEvent = function (feature) {
    const candidates = this.listFeatureEvents(feature).filter((event) => event.getTimeAfterFinish() > 0).sort((a, b) => a.getTimeAfterFinish() - b.getTimeAfterFinish());

    return candidates[0];
};

EventManager.prototype.setCustomFeature = function (feature, duration) {
    this.events = this.events.filter((event) => !event.tool || !event.features.includes(feature));

    const month = new Date().getMonth();
    const periodEvent = this.listFeatureEvents(feature).find((event) => event.options.period && event.start.getMonth() === month);

    const now = Date.now();
    const event = new cleverapps.Event({
        tool: true,
        features: [feature],
        options: periodEvent && { ...periodEvent.options }
    });
    event.start = new Date(now - 1000);
    event.finish = new Date(now + duration);

    this.events.push(event);

    this.setCurrentFeatures();
};
